import { Subtitle } from "src/atoms/typography";

export default function MenuItemText(props) {
  return <Subtitle mr="32px" flexGrow={1} color="highEmphasis" {...props} />;
}
